import { render, staticRenderFns } from "./Appointments.vue?vue&type=template&id=a0446a74"
import script from "./Appointments.vue?vue&type=script&lang=js"
export * from "./Appointments.vue?vue&type=script&lang=js"
import style0 from "./Appointments.vue?vue&type=style&index=0&id=a0446a74&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports